export default __webpack_public_path__ + "static/media/200.a52bbd72.png";